import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarSlim } from '../TopBarSlim';
import { UseCaseVariationEnums } from '../TopBarSlimEnums';

const DEFAULT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseCourseTrainingFeedbackTopBarSlim.message',
    defaultMessage:
      'Let respondents upload work, documents, and more for easier tracking and scoring.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseCourseTrainingFeedbackTopBarSlim.ctaText',
    defaultMessage: 'See all plans',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const COLLECT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseCourseTrainingFeedbackTopBarSlim.messageCollect',
    defaultMessage:
      'Give each participant a voice with a plan that unlocks unlimited survey responses.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseCourseTrainingFeedbackTopBarSlim.ctaTextCollect',
    defaultMessage: 'See all plans',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const ANALYZE_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseCourseTrainingFeedbackTopBarSlim.messageAnalyze',
    defaultMessage:
      "Monitor trainee progress and save participants' scores with advanced export options.",
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseCourseTrainingFeedbackTopBarSlim.ctaTextAnalyze',
    defaultMessage: 'See all plans',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

export type UseCaseCourseTrainingFeedbackTopBarSlimProps = {
  variation?: UseCaseVariationEnums | null;
};

const VariationToCopy = {
  [UseCaseVariationEnums.create]: DEFAULT_COPY,
  [UseCaseVariationEnums.collect]: COLLECT_COPY,
  [UseCaseVariationEnums.analyze]: ANALYZE_COPY,
};

export const UseCaseCourseTrainingFeedbackTopBarSlim: React.FC<UseCaseCourseTrainingFeedbackTopBarSlimProps> = ({
  variation,
}) => {
  const copy =
    variation && variation in VariationToCopy
      ? VariationToCopy[variation]
      : DEFAULT_COPY;
  const ut_source = variation
    ? `slim_${variation}_upsell_course_training`
    : 'slim_create_upsell_course_training';

  return (
    <TopBarSlim
      message={t(copy.MESSAGE)}
      ctaText={t(copy.CTA_TEXT)}
      ctaLink={createURL('/pricing/upgrade/', {
        ut_source: 'topbar',
        ut_source2: ut_source,
      })}
      ctaNewTab
    />
  );
};

export default UseCaseCourseTrainingFeedbackTopBarSlim;
